import React from 'react'
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer'
import Nav from '../../components/Nav/Nav'
import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';




//data
import {forms} from './Downloadables'
import FormTable from '../../components/FormTable/FormTable'

export default class AccountActivity extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={

        }
    }
    
    componentDidMount=()=>{
        
    }
    

    render(){
        return <div ref={this.parentRef} style={{display:'flex',height:"auto", width:'auto',flexDirection:'column', backgroundColor:Colors.light_grey,overflowX:'hidden'}}>
            <Header authed={true} navigator={this.props.navigator}/>
            <div style={{ display:'flex', flexDirection:'row', backgroundColor:Colors.light_grey}}>
                <div style={{ display:'flex',flex:1,justifyContent:'right',alignItems:'right'}}>
                    <Nav navigator={this.props.navigator} page='resources'/>
                </div>
                <div style={{ display:'flex',flexDirection:'column',flex:3, paddingTop:'2.4vh', paddingLeft:"1vw",paddingRight:'20vw'}}>
                    <div>{/**Title*/}
                        <span style={{...Fonts.title,color:"#003F97"}}><span style={{...Fonts.title,color:'#000'}}>Resources</span></span>
                    </div>
                    <div style={{background:"#FFF",width:"47vw",height:'120vh', border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:'2.3vh'}}>{/**white view */}
                        <div style={{display:'flex',flexDirection:'row',alignItems:'center', marginTop:'2.8vh', marginLeft:'1vw'}}>{/**white view header */}
                            <span style={{...Fonts.title, }}>Forms and Documents</span>
                        </div>
                        <div style={{display:'flex',height:1,backgroundColor:Colors.grey,marginLeft:'1vw',marginRight:'1vw',marginTop:'1.5vh'}}/>
                        <FormTable forms={forms.irs_forms}/>

                    </div>
                    <div style={{display:'flex',height:'9vh', background:Colors.light_grey,}}></div>
                </div>
                
            </div>
            
            <Footer/>
        </div>
    }
}